import React, { useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { useAuthStore } from '../../stores/authStore';
import { userApi } from '../../lib/api';
import { useInvoiceStore } from '../../stores/invoiceStore';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { setUser, setLoading, checkAdminStatus } = useAuthStore();
  const { updateSettings } = useInvoiceStore();

  useEffect(() => {
    setLoading(true);
    
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      console.log('[AuthProvider] Auth state changed:', { 
        isAuthenticated: !!firebaseUser,
        email: firebaseUser?.email
      });

      setUser(firebaseUser);

      if (firebaseUser) {
        try {
          // Check admin status first
          await checkAdminStatus();

          // Then fetch user settings
          console.log('[AuthProvider] Fetching user settings...');
          const settings = await userApi.getSettings();
          if (settings) {
            console.log('[AuthProvider] Settings fetched:', settings);
            updateSettings(settings);
          }
        } catch (error) {
          console.error('[AuthProvider] Failed to fetch settings:', error);
        }
      }

      setLoading(false);
    });

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Firebase auth listener should only be set up once. Zustand actions are stable.

  return <>{children}</>;
}; 